import React from 'react';
import { Card, Button, Badge, Spinner, Alert, Row, Col, Nav } from 'react-bootstrap';
import {
    FaEye,
    FaBan,
    FaUserTie,
    FaCalendarAlt,
    FaMapMarkerAlt,
    FaClock,
    FaHandshake,
    FaExclamationTriangle,
    FaFilter,
    FaCheckCircle,
    FaTimesCircle
} from 'react-icons/fa';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import HeaderTopSection from "../../components/partials/HeaderTop";
import Banner from "../../components/partials/Banner";
import ClientEOIDetailModal from '../../components/modals/professionalCandidate/ClientEOIDetailModal';
import ChangeProfessionalModal from '../../components/modals/professionalCandidate/ChangeProfessionalModal';
import useClientEOIList from './hooks/useClientEOIList';

const ClientEOIListPage = () => {
    const {
        eois,
        filteredEois,
        activeFilter,
        isLoading,
        error,
        selectedEOI,
        isModalOpen,
        cancellingId,
        lightboxOpen,
        lightboxImages,
        lightboxIndex,
        filterStats,
        getStatusBadge,
        getStatusText,
        formatFrequency,
        formatDate,
        formatCurrency,
        getServiceImage,
        getProfessionalProfilePicture,
        handleFilterChange,
        handleCancelRequest,
        handleViewDetails,
        handleUpdate,
        handleCloseModal,
        handleOpenLightbox,
        handleCloseLightbox,
        fetchClientEOIs,
        isChangeProfessionalModalOpen,
        eoiToChangeProfessional,
        handleOpenChangeProfessionalModal,
        handleCloseChangeProfessionalModal,
        handleProfessionalChanged
    } = useClientEOIList();

    return (
        <>
            <HeaderTopSection />
            <Banner
                title="Mes demandes aux professionnels"
            />

            <div className="container-fluid py-4" style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
                <div className="container">
                    <div className="row">
                        {/* Sidebar de filtrage améliorée */}
                        <div className="col-lg-3 mb-4">
                            <Card className="shadow-sm border-0 sticky-top" style={{ top: '100px', borderRadius: '16px', overflow: 'hidden' }}>
                                <Card.Header className="bg-gradient text-white border-0 py-4" style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                }}>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <FaFilter className="me-2" size={20} />
                                        <h5 className="mb-0 fw-bold">Filtrer les demandes</h5>
                                    </div>
                                </Card.Header>
                                <Card.Body className="p-0">
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link
                                                className={`filter-nav-link d-flex justify-content-between align-items-center py-3 px-4 ${activeFilter === 'PENDING' ? 'active-pending' : ''}`}
                                                onClick={() => handleFilterChange('PENDING')}
                                                style={{
                                                    cursor: 'pointer',
                                                    borderRadius: 0,
                                                    borderLeft: activeFilter === 'PENDING' ? '4px solid #ffc107' : '4px solid transparent',
                                                    transition: 'all 0.3s ease',
                                                    backgroundColor: activeFilter === 'PENDING' ? '#fff3cd' : 'transparent'
                                                }}
                                            >
                                                <span className="d-flex align-items-center">
                                                    <FaClock className="me-2" style={{ color: activeFilter === 'PENDING' ? '#ffc107' : '#6c757d' }} />
                                                    <span className={`fw-${activeFilter === 'PENDING' ? 'bold' : 'medium'}`}>En attente</span>
                                                </span>
                                                <Badge
                                                    bg={activeFilter === 'PENDING' ? 'warning' : 'light'}
                                                    text={activeFilter === 'PENDING' ? 'dark' : 'secondary'}
                                                    pill
                                                    className="px-3 py-2"
                                                >
                                                    {filterStats.PENDING}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                className={`filter-nav-link d-flex justify-content-between align-items-center py-3 px-4 ${activeFilter === 'APPROVED' ? 'active-approved' : ''}`}
                                                onClick={() => handleFilterChange('APPROVED')}
                                                style={{
                                                    cursor: 'pointer',
                                                    borderRadius: 0,
                                                    borderLeft: activeFilter === 'APPROVED' ? '4px solid #28a745' : '4px solid transparent',
                                                    transition: 'all 0.3s ease',
                                                    backgroundColor: activeFilter === 'APPROVED' ? '#d4edda' : 'transparent'
                                                }}
                                            >
                                                <span className="d-flex align-items-center">
                                                    <FaCheckCircle className="me-2" style={{ color: activeFilter === 'APPROVED' ? '#28a745' : '#6c757d' }} />
                                                    <span className={`fw-${activeFilter === 'APPROVED' ? 'bold' : 'medium'}`}>Approuvées</span>
                                                </span>
                                                <Badge
                                                    bg={activeFilter === 'APPROVED' ? 'success' : 'light'}
                                                    text={activeFilter === 'APPROVED' ? 'white' : 'secondary'}
                                                    pill
                                                    className="px-3 py-2"
                                                >
                                                    {filterStats.APPROVED}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                className={`filter-nav-link d-flex justify-content-between align-items-center py-3 px-4 ${activeFilter === 'REJECTED' ? 'active-rejected' : ''}`}
                                                onClick={() => handleFilterChange('REJECTED')}
                                                style={{
                                                    cursor: 'pointer',
                                                    borderRadius: 0,
                                                    borderLeft: activeFilter === 'REJECTED' ? '4px solid #dc3545' : '4px solid transparent',
                                                    transition: 'all 0.3s ease',
                                                    backgroundColor: activeFilter === 'REJECTED' ? '#f8d7da' : 'transparent'
                                                }}
                                            >
                                                <span className="d-flex align-items-center">
                                                    <FaTimesCircle className="me-2" style={{ color: activeFilter === 'REJECTED' ? '#dc3545' : '#6c757d' }} />
                                                    <span className={`fw-${activeFilter === 'REJECTED' ? 'bold' : 'medium'}`}>Rejetées</span>
                                                </span>
                                                <Badge
                                                    bg={activeFilter === 'REJECTED' ? 'danger' : 'light'}
                                                    text={activeFilter === 'REJECTED' ? 'white' : 'secondary'}
                                                    pill
                                                    className="px-3 py-2"
                                                >
                                                    {filterStats.REJECTED}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Card.Body>
                            </Card>
                        </div>

                        {/* Contenu principal */}
                        <div className="col-lg-9">
                            {isLoading ? (
                                <div className="text-center py-5">
                                    <Spinner animation="border" variant="primary" size="lg" />
                                    <p className="mt-3 fs-5 text-muted">Chargement de vos demandes...</p>
                                </div>
                            ) : error ? (
                                <Alert variant="danger" className="mx-auto" style={{ maxWidth: '600px' }}>
                                    <div className="text-center">
                                        <FaExclamationTriangle size={32} className="mb-3 text-danger" />
                                        <h5 className="alert-heading">Erreur de chargement</h5>
                                        <p className="mb-3">{error}</p>
                                        <Button variant="primary" onClick={fetchClientEOIs} size="lg">
                                            Réessayer le chargement
                                        </Button>
                                    </div>
                                </Alert>
                            ) : filteredEois.length === 0 ? (
                                <div className="text-center py-5">
                                    <div className="py-5">
                                        <FaFilter size={64} className="text-muted mb-4" />
                                        <h3 className="text-muted mb-3">
                                            {activeFilter === 'PENDING' ? 'Aucune demande en attente' :
                                                activeFilter === 'APPROVED' ? 'Aucune demande approuvée' :
                                                    'Aucune demande rejetée'}
                                        </h3>
                                        <p className="text-muted fs-5 mb-4">
                                            Aucune demande ne correspond au filtre sélectionné.
                                        </p>
                                        <Button variant="primary" size="lg" href="/professional-candidate">
                                            Voir les professionnels
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                <Row xs={1} md={2} className="g-4">
                                    {filteredEois.map(eoi => (
                                        <Col key={eoi.id}>
                                            <Card className="h-100 shadow-lg border-0 hover-lift"
                                                  style={{
                                                      borderRadius: '16px',
                                                      transition: 'all 0.3s ease',
                                                      border: eoi.clientEOIStatus === 'APPROVED' ? '2px solid #28a745' :
                                                          eoi.clientEOIStatus === 'REJECTED' ? '2px solid #dc3545' : '2px solid transparent'
                                                  }}>
                                                {/* Image du service - avec Lightbox */}
                                                <div
                                                    className="position-relative"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        const imageUrl = getServiceImage(eoi);
                                                        const images = [{ src: imageUrl, alt: eoi.serviceName || 'Image du service' }];
                                                        // Ajouter d'autres images si disponibles
                                                        if (eoi.mediaSubscriptions) {
                                                            eoi.mediaSubscriptions.forEach(media => {
                                                                images.push({
                                                                    src: media.urlPresigned || media.url,
                                                                    alt: media.name || 'Image'
                                                                });
                                                            });
                                                        }
                                                        handleOpenLightbox(images, 0);
                                                    }}
                                                >
                                                    <Card.Img
                                                        variant="top"
                                                        src={getServiceImage(eoi)}
                                                        style={{
                                                            height: '180px',
                                                            objectFit: 'cover',
                                                            borderTopLeftRadius: '16px',
                                                            borderTopRightRadius: '16px'
                                                        }}
                                                        onError={(e) => {
                                                            e.target.src = "/assets/images/default-service.jpg";
                                                        }}
                                                    />
                                                    <div className="position-absolute top-0 end-0 m-3">
                                                        {getStatusBadge(eoi.clientEOIStatus)}
                                                    </div>
                                                    <div
                                                        className="position-absolute top-0 start-0 m-2 bg-dark bg-opacity-50 rounded-circle p-1"
                                                        style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                    >
                                                        <FaEye size={14} color="white" />
                                                    </div>
                                                </div>

                                                <Card.Body className="d-flex flex-column p-4">
                                                    {/* En-tête avec photo du professionnel */}
                                                    <div className="d-flex align-items-center mb-3">
                                                        <div className="me-3">
                                                            {(() => {
                                                                const profilePic = getProfessionalProfilePicture(eoi.professional);
                                                                return profilePic ? (
                                                                    <img
                                                                        src={profilePic}
                                                                        alt="Profile"
                                                                        style={{
                                                                            width: '60px',
                                                                            height: '60px',
                                                                            borderRadius: '50%',
                                                                            objectFit: 'cover',
                                                                            border: '3px solid #fff',
                                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                                                        }}
                                                                        onError={(e) => {
                                                                            e.target.style.display = 'none';
                                                                            e.target.parentElement.innerHTML = `
                                                                                <div class="bg-primary rounded-circle p-3 d-flex align-items-center justify-content-center"
                                                                                     style="width: 60px; height: 60px;">
                                                                                    <FaUserTie size={24} class="text-white" />
                                                                                </div>
                                                                            `;
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <div className="bg-primary rounded-circle p-3 d-flex align-items-center justify-content-center"
                                                                         style={{width: '60px', height: '60px'}}>
                                                                        <FaUserTie size={24} className="text-white" />
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <h5 className="mb-1 text-dark fw-bold">
                                                                {eoi.professional?.user?.firstName} {eoi.professional?.user?.lastName}
                                                            </h5>
                                                        </div>
                                                    </div>

                                                    {/* Informations du professionnel */}
                                                    <div className="mb-3">
                                                        <div className="d-flex align-items-center mb-2">
                                                            <FaMapMarkerAlt className="me-2 text-success" size={14} />
                                                            <small className="text-dark fw-medium">
                                                                {eoi.serviceLocation || 'Ville non disponible'}
                                                            </small>
                                                        </div>
                                                        <div className="d-flex align-items-center mb-2">
                                                            <FaCalendarAlt className="me-2 text-success" size={14} />
                                                            <small className="text-dark fw-medium">
                                                                <small>Date de début souhaitée</small> <small style={{fontWeight:'bold',}}>{formatDate(eoi.desiredStartDate)}</small>
                                                            </small>
                                                        </div>
                                                        {eoi.serviceFee && (
                                                            <div className="d-flex align-items-center">
                                                                <span className="fw-bold text-success me-2" style={{ fontSize: '14px' }}>
                                                                  FCFA
                                                                </span>
                                                                <small className="text-success fw-bold">
                                                                    {formatCurrency(eoi.serviceFee)}
                                                                </small>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Informations de la demande */}
                                                    <div className="mb-3">
                                                        <div className="d-flex align-items-center mb-2 text-muted">
                                                            <FaCalendarAlt className="me-2" size={14} />
                                                            <small>Créée le {formatDate(eoi.createdAt)}</small>
                                                        </div>
                                                    </div>

                                                    {/* Détails du contrat */}
                                                    <div className="mb-3 p-3 bg-light rounded-3">
                                                        <div className="row g-2">
                                                            <div className="col-6">
                                                                <small className="text-muted d-block">Durée</small>
                                                                <div className="fw-bold text-dark">
                                                                    {eoi.contractDuration || 'Non spécifié'} Mois
                                                                </div>
                                                            </div>
                                                            <div className="col-6">
                                                                <small className="text-muted d-block">Service</small>
                                                                <div className="fw-bold text-dark text-truncate" title={eoi.serviceName}>
                                                                    {eoi.serviceName || eoi.professional?.selectedService || 'Non spécifié'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/* Changer de prestataire */}
                                                    {(eoi.clientEOIStatus === 'PENDING' || eoi.clientEOIStatus === 'APPROVED') && (
                                                        <div className="mb-2">
                                                            <Button
                                                                variant="primary"
                                                                className="w-100"
                                                                onClick={() => handleOpenChangeProfessionalModal(eoi)}
                                                            >
                                                                <FaUserTie className="me-2" /> Changer de prestataire
                                                            </Button>
                                                        </div>
                                                    )}

                                                    {/* Actions */}
                                                    <div className="mt-auto d-flex gap-2">
                                                        <Button
                                                            variant="primary"
                                                            className={eoi.clientEOIStatus === 'PENDING' ? 'flex-grow-1' : 'w-100'}
                                                            onClick={() => handleViewDetails(eoi)}
                                                            size="lg"
                                                        >
                                                            <FaEye className="me-2" /> Voir détails
                                                        </Button>
                                                        {eoi.clientEOIStatus === 'PENDING' && (
                                                            <Button
                                                                variant="danger"
                                                                className="flex-grow-1"
                                                                onClick={() => handleCancelRequest(eoi)}
                                                                disabled={cancellingId === eoi.id}
                                                                size="lg"
                                                            >
                                                                {cancellingId === eoi.id ? (
                                                                    <>
                                                                        <Spinner animation="border" size="sm" className="me-2" />
                                                                        Annulation...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <FaBan className="me-2" /> Annuler
                                                                    </>
                                                                )}
                                                            </Button>
                                                        )}
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de détail */}
            {isModalOpen && selectedEOI && (
                <ClientEOIDetailModal
                    eoi={selectedEOI}
                    show={isModalOpen}
                    onClose={handleCloseModal}
                    onUpdate={handleUpdate}
                />
            )}

            {isChangeProfessionalModalOpen && eoiToChangeProfessional && (
                <ChangeProfessionalModal
                    show={isChangeProfessionalModalOpen}
                    onClose={handleCloseChangeProfessionalModal}
                    clientEOIId={eoiToChangeProfessional.id}
                    currentProfessionalId={eoiToChangeProfessional.professional?.id}
                    defaultCity={eoiToChangeProfessional.professional?.city}
                    defaultService={eoiToChangeProfessional.professional?.selectedService}
                    onSuccess={handleProfessionalChanged}
                />
            )}

            {/* Lightbox pour les images */}
            <Lightbox
                open={lightboxOpen}
                close={handleCloseLightbox}
                slides={lightboxImages}
                index={lightboxIndex}
                styles={{
                    container: { backgroundColor: 'rgba(0, 0, 0, 0.95)' },
                    button: { color: 'white' }
                }}
            />

            <style jsx>{`
                .hover-lift:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 12px 25px rgba(0,0,0,0.15) !important;
                }
                .swal2-popup-custom {
                    border-radius: 16px !important;
                }
                .sticky-top {
                    position: sticky;
                    z-index: 100;
                }
                .filter-nav-link {
                    position: relative;
                }
                .filter-nav-link:hover {
                    background-color: #f8f9fa !important;
                }
                .filter-nav-link.active-pending:hover {
                    background-color: #fff3cd !important;
                }
                .filter-nav-link.active-approved:hover {
                    background-color: #d4edda !important;
                }
                .filter-nav-link.active-rejected:hover {
                    background-color: #f8d7da !important;
                }
            `}</style>
        </>
    );
};

export default ClientEOIListPage;